import { Category, ContentType } from '@/admin/utils/categoryService';
import { CACHE_KEYS, getCache, setCache, deleteCache } from './cacheService';

/**
 * Lấy danh mục từ cache dựa trên loại nội dung
 * @param contentType Loại nội dung (course, diagram, post, all)
 * @returns Danh sách danh mục từ cache hoặc null
 */
export const getCategoriesByType = (contentType: ContentType): Category[] | null => {
  let cacheKey: string;
  
  switch (contentType) {
    case ContentType.COURSE:
      cacheKey = CACHE_KEYS.COURSE_CATEGORIES;
      break;
    case ContentType.DIAGRAM:
      cacheKey = CACHE_KEYS.DIAGRAM_CATEGORIES;
      break;
    case ContentType.POST:
      cacheKey = CACHE_KEYS.POST_CATEGORIES;
      break;
    case ContentType.ALL:
    default:
      cacheKey = CACHE_KEYS.ALL_CATEGORIES;
      break;
  }
  
  return getCache<Category[]>(cacheKey);
};

/**
 * Lưu danh mục vào cache dựa trên loại nội dung
 * @param categories Danh sách danh mục cần lưu
 * @param contentType Loại nội dung (course, diagram, post, all)
 * @param duration Thời gian sống của cache (ms)
 */
export const setCategoriesByType = (
  categories: Category[], 
  contentType: ContentType,
  duration = 24 * 60 * 60 * 1000
): void => {
  let cacheKey: string;
  
  switch (contentType) {
    case ContentType.COURSE:
      cacheKey = CACHE_KEYS.COURSE_CATEGORIES;
      break;
    case ContentType.DIAGRAM:
      cacheKey = CACHE_KEYS.DIAGRAM_CATEGORIES;
      break;
    case ContentType.POST:
      cacheKey = CACHE_KEYS.POST_CATEGORIES;
      break;
    case ContentType.ALL:
    default:
      cacheKey = CACHE_KEYS.ALL_CATEGORIES;
      break;
  }
  
  setCache(cacheKey, categories, duration);
};

/**
 * Xóa tất cả cache liên quan đến danh mục
 */
export const clearAllCategoriesCache = (): void => {
  deleteCache(CACHE_KEYS.CATEGORIES);
  deleteCache(CACHE_KEYS.ALL_CATEGORIES);
  deleteCache(CACHE_KEYS.COURSE_CATEGORIES);
  deleteCache(CACHE_KEYS.DIAGRAM_CATEGORIES);
  deleteCache(CACHE_KEYS.POST_CATEGORIES);
};

/**
 * Lọc danh mục theo loại nội dung
 * @param categories Danh sách danh mục cần lọc
 * @param contentType Loại nội dung cần lọc
 * @returns Danh sách danh mục đã lọc
 */
export const filterCategoriesByContentType = (
  categories: Category[],
  contentType: ContentType
): Category[] => {
  if (contentType === ContentType.ALL) {
    return categories;
  }
  
  return categories.filter(category => 
    !category.content_type || 
    category.content_type === ContentType.ALL || 
    category.content_type === contentType
  );
};

/**
 * Chuyển đổi danh mục cũ sang định dạng mới
 * @param oldCategory Danh mục cũ
 * @param contentType Loại nội dung
 * @returns Danh mục mới
 */
export const convertToNewCategoryFormat = (
  oldCategory: any,
  contentType: ContentType
): Category => {
  return {
    id: oldCategory.id,
    name: oldCategory.name,
    description: oldCategory.description || '',
    image_url: oldCategory.image_url || '',
    slug: oldCategory.slug || oldCategory.id,
    icon: oldCategory.icon || '',
    color: oldCategory.color || '#3B82F6',
    content_type: contentType,
  };
};